// @generated by protoc-gen-es v2.10.0 with parameter "target=ts,import_extension=none"
// @generated from file proto/sem/team/team_selection.proto (package sem.team.team_selection, syntax proto3)
/* eslint-disable */

import type { Message } from "@bufbuild/protobuf";
import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/sem/team/team_selection.proto.
 */
export const file_proto_sem_team_team_selection: GenFile = /*@__PURE__*/
  fileDesc("CiNwcm90by9zZW0vdGVhbS90ZWFtX3NlbGVjdGlvbi5wcm90bxIXc2VtLnRlYW0udGVhbV9zZWxlY3Rpb24icwoRVGVhbU1lbWJlclBheWxvYWQSDAoEbmFtZRgBIAEoCRIRCglwZXJzb25faWQYAiABKAkSDQoFZW1haWwYAyABKAkSDAoEcm9sZRgEIAEoCRIRCglyb2xlX3RleHQYBSABKAkSDQoFc2NvcmUYBiABKAEiXAoPVGVhbU1lbWJlckFkZGVkEg8KB2l0ZW1faWQYASABKAkSOAoEZGF0YRgCIAEoCzIqLnNlbS50ZWFtLnRlYW1fc2VsZWN0aW9uLlRlYW1NZW1iZXJQYXlsb2FkQkpaSGdpdGh1Yi5jb20vdGVhbS1tZW50by9tZW50by1wbGF5Z3JvdW5kL2dvL3BrZy9zZW0vcGIvcHJvdG8vc2VtL3RlYW07dGVhbWIGcHJvdG8z");

/**
 * Payload for team member messages
 *
 * @generated from message sem.team.team_selection.TeamMemberPayload
 */
export type TeamMemberPayload = Message<"sem.team.team_selection.TeamMemberPayload"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * resolved by backend, not provided by LLM
   *
   * @generated from field: string person_id = 2;
   */
  personId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: string role_text = 5;
   */
  roleText: string;

  /**
   * optional by presence (0 means unset)
   *
   * @generated from field: double score = 6;
   */
  score: number;
};

/**
 * Describes the message sem.team.team_selection.TeamMemberPayload.
 * Use `create(TeamMemberPayloadSchema)` to create a new message.
 */
export const TeamMemberPayloadSchema: GenMessage<TeamMemberPayload> = /*@__PURE__*/
  messageDesc(file_proto_sem_team_team_selection, 0);

/**
 * @generated from message sem.team.team_selection.TeamMemberAdded
 */
export type TeamMemberAdded = Message<"sem.team.team_selection.TeamMemberAdded"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: sem.team.team_selection.TeamMemberPayload data = 2;
   */
  data?: TeamMemberPayload;
};

/**
 * Describes the message sem.team.team_selection.TeamMemberAdded.
 * Use `create(TeamMemberAddedSchema)` to create a new message.
 */
export const TeamMemberAddedSchema: GenMessage<TeamMemberAdded> = /*@__PURE__*/
  messageDesc(file_proto_sem_team_team_selection, 1);

